module.exports = __webpack_public_path__ + "static/pyry2-5fd326476b7ae29cdb8678eaf8777f29.jpg";